import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	empty: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.empty',
		defaultMessage: 'No issues',
		description: 'Message in the card describing that the epic does not have any issues.',
	},
	viewAllDetails: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.view-all-details',
		defaultMessage: 'View all details',
		description: 'Text of the button to view all details of an epic',
	},
	viewDetails: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.view-details',
		defaultMessage: 'View details',
		description: 'Text of the button to view details of an epic',
	},
	createIssue: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.create-issue',
		defaultMessage: 'Create issue',
		description: 'Text of the button to create an issue linked to this epic',
	},
	startDate: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.start-date',
		defaultMessage: 'Start date',
		description: 'Label for the start date of an epic',
	},
	dueDate: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.due-date',
		defaultMessage: 'Due date',
		description: 'Label for the due date of an epic',
	},
	createIssueIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.create-issue-issue-term-refresh',
		defaultMessage: 'Create work item',
		description: 'Text of the button to create an issue linked to this epic',
	},
	emptyIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.empty-issue-term-refresh',
		defaultMessage: 'No work items',
		description: 'Message in the card describing that the epic does not have any issues.',
	},
});
